// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"55b6ab4c","990":"c89dac83"}[chunkId] + ".chunk.css";
};